import { dateFormat } from "shared/util"
import { Box, Link, Stack, StackProps, Typography } from "@mui/material"
import { FiberNew as NewIcon } from '@mui/icons-material'

import { NotificationResult } from "interface/notification"
import { NotificationLogoImage, OpenNotificationLogoImage } from "./logoImage"
import { NotificationCategoryChip } from "./categoryChip"

type NotificationHeadlineProps = {
	domain?: string
	notification: NotificationResult
	isNew?: boolean
	link?: string | null
	onLinkClick?: () => void
} & StackProps
export const NotificationHeadline = ({
	domain,
	notification,
	isNew,
	link,
	onLinkClick,
	...others
}: NotificationHeadlineProps) => (
	<Stack {...others} direction='row' spacing={1} width='100%'>
		{domain ? (
			<OpenNotificationLogoImage
				domain={domain}
				notification={notification}
				style={{ width: "100px", flexShrink: 0 }}
			/>
		) : (
			<NotificationLogoImage
				notification={notification}
				style={{ width: "100px", flexShrink: 0 }}
			/>
		)}
		<Stack direction='column' flexGrow={1} spacing={0.5}>
			<Stack direction='row' spacing={1} alignItems='center' sx={{ fontSize: '60%' }}>
				{isNew === true ? <NewIcon fontSize="small" color="warning"/> : <></>}
				<NotificationCategoryChip category={notification.category}/>
				<Box flexGrow={1}/>
				<Typography variant="body2" color='text.secondary'>{dateFormat(notification.updateTime)}</Typography>
			</Stack>
			{link ? (
				<Link href={link} target="_blank" rel="noopener" onClick={onLinkClick} underline='hover'>
					<Typography variant="body1">{notification.title}</Typography>
				</Link>
			) : (
				<Typography variant="body1">{notification.title}</Typography>
			)}
		</Stack>
	</Stack>
)
